import React from 'react';
import VideoMetaData from '../components/VideoMetaData';
import Layout from '../../../Layout';
import Comments from '../comments/Comments';
import MobileViewSearch from '../../../component/MobileViewSearch';

function PlayerPageLayouts({ children, fetchedVideo, isPromo = false }) {
	return (
		<Layout
			title={fetchedVideo?.title || 'Elevate Your Dance Skills with our Online Dance Classes'}
			description={
				fetchedVideo?.description?.split('\n')[0] || 'Get your dance critiqued by Jonathan or Chelsea Godfrey'
			}
		>
			<div className="row m-0 c-mobile_honm-serch">
				<MobileViewSearch />
			</div>
			<div className="Video-Container">
				{children}
				<VideoMetaData selectedVideo={fetchedVideo} isPromo={isPromo} />
				{!isPromo && <Comments />}
			</div>
		</Layout>
	);
}

export default PlayerPageLayouts;
